import { connect } from "react-redux";
import AddToDealerWallet from './AddToDealerWallet';
import { bindActionCreators } from "redux";
import {addMoney,fetchDealerDetails,savePaymentForDealer} from "../../../services/redux/Wallet/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    addedMoney : state.Wallet.addedMoney,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    dealerData : state.Wallet.dealerData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        addMoney,
        documentUploadUrlPublic,
        fetchDealerDetails,
        savePaymentForDealer
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddToDealerWallet);